export default {
  roles: 'roles',
  role: 'role',
  add: 'add role',
  details: 'role details',
  name: 'name',
  permissions: 'permissions'
}
